import React from 'react';
import * as styles from './OrganizationOnboardingModal.module.scss';
import OrganizationOnboardingStepAuth from './OrganizationOnboardingStepAuth';
import OrganizationOnboardingStepInvite from './OrganizationOnboardingStepInvite';
import OrganizationOnboardingStepProfile from './OrganizationOnboardingStepProfile';
import OrganizationOnboardingStepTeam from './OrganizationOnboardingStepTeam';

const STEPS = [
  { name: 'Authentication', component: OrganizationOnboardingStepAuth },
  { name: 'Team', component: OrganizationOnboardingStepTeam },
  { name: 'Profile', component: OrganizationOnboardingStepProfile },
  { name: 'Invite', component: OrganizationOnboardingStepInvite },
] as const;

export const AUTHENTICATION_STEP = 0;
export const INVITE_STEP = 1;

interface OrganizationOnboardingModalProps {
  step: number;
  onComplete: () => void;
  onSkip: () => void;
  onUpdateStep: (step: number) => void;
}

const OrganizationOnboardingModal = ({
  step,
  onComplete,
  onSkip,
  onUpdateStep,
}: OrganizationOnboardingModalProps) => {
  const { component: StepComponent } = STEPS[step] ?? {};

  if (!StepComponent) {
    return null;
  }

  const onNext = () => {
    if (step === STEPS.length - 1) {
      onComplete();
    } else {
      onUpdateStep(step + 1);
    }
  };

  const onPrevious =
    step > 0
      ? () => {
          onUpdateStep(step - 1);
        }
      : null;

  return (
    <div className={styles.modal}>
      <StepComponent
        lastStep={step === STEPS.length - 1}
        step={step}
        onSkip={onSkip}
        onNext={onNext}
        onPrevious={onPrevious}
      />
    </div>
  );
};

export default OrganizationOnboardingModal;
